import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { API } from '../config';
import './Auth.css';

function RecruiterLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(formData);
      const { access_token, user_type, full_name, user_id, subscription_tier } = response.data;

      if (user_type !== 'RECRUITER') {
        setError('This portal is for recruiters only. Please use the job seeker login.');
        setLoading(false);
        return;
      }

      localStorage.setItem('token', access_token);
      localStorage.setItem('user_type', user_type);
      localStorage.setItem('user_name', full_name || '');
      localStorage.setItem('user_tier', subscription_tier || 'starter');
      if (user_id) localStorage.setItem('user_id', user_id);

      // Check if recruiter profile exists
      try {
        const profileRes = await fetch(`${API}/recruiter-profile/me/`, {
          headers: { 'Authorization': `Bearer ${access_token}` }
        });
        navigate(profileRes.ok ? '/recruiter/dashboard' : '/recruiter/profile-setup');
      } catch {
        navigate('/recruiter/dashboard');
      }
    } catch (err) {
      const detail = err.response?.data?.detail || 'Login failed. Please try again.';
      const isUnverified = err.response?.status === 403 && detail.toLowerCase().includes('verify');
      if (isUnverified) {
        setError('__unverified__:' + formData.username);
      } else {
        setError(detail);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-stars">
        {[...Array(10)].map((_, i) => (
          <div key={i} className="auth-star"></div>
        ))}
      </div>
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" style={{textDecoration: 'none'}}>
            <img src="/JobLinkedAI.png" alt="JobLinked AI" style={{height: '80px', marginBottom: '1rem'}} />
          </Link>
          <h2>Recruiter Portal</h2>
          <p>Sign in to manage your job postings</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              required
              placeholder="recruiter@company.com"
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              placeholder="••••••••"
            />
          </div>

          {error && error.startsWith('__unverified__:') ? (
            <div className="error" style={{ lineHeight: 1.6 }}>
              Your email is not verified yet.{' '}
              <button
                style={{ background: 'none', border: 'none', color: '#fbbf24', cursor: 'pointer', fontWeight: 700, textDecoration: 'underline', padding: 0, fontSize: 'inherit' }}
                onClick={async () => {
                  const email = error.split('__unverified__:')[1];
                  await fetch(`${API}/auth/resend-verification?email=${encodeURIComponent(email)}`, { method: 'POST' });
                  setError('Verification email resent — check your inbox.');
                }}
              >
                Resend verification email
              </button>
            </div>
          ) : error ? (
            <div className="error">{error}</div>
          ) : null}

          <button type="submit" className="btn btn-full" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Don't have an account? <Link to="/recruiter/register">Sign up</Link></p>
          <p style={{marginTop: '0.5rem'}}>
            <Link to="/login">Job seeker? Sign in here</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RecruiterLogin;
